/**
 * 地块管理
 */
<template>
  <div>
    <div id="DataPage" class="fieldManage" v-if="isShowDataPage">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>FieldManage</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item>
          <el-input suffix-icon="el-icon-search" v-model="formInline.searchContent" placeholder="searchContent"
            style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-tooltip class="item" content="fromtime 00:00:00" placement="top-start">
            <el-date-picker v-model="formInline.startTime" value-format="yyyy-MM-dd hh:mm:ss" type="date"
              placeholder="FromDate" class="searchDate" />
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-tooltip class="item" content="endtime 00:00:00" placement="top-start">
            <el-date-picker v-model="formInline.endTime" value-format="yyyy-MM-dd hh:mm:ss" type="date"
              placeholder="EndDate" class="searchDate" />
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-search" @click="search">Search</el-button></el-form-item>

        <el-form-item style="float: right">
          <!-- 预览 -->
          <el-button type="primary" icon="el-icon-view" @click="viewSelected">ViewSelected
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <!-- 下载 -->
          <el-button id="downloadBtn" type="primary" icon="el-icon-download" @click="downloadSelected">DownloadSelected
          </el-button>
        </el-form-item>
        <!-- 上传 -->
        <el-form-item style="float: right">
          <el-tooltip
            placement="top-start">
            <div slot="content">
              Rules:
              <br />1. File format: .kml, .kmz or .zip(shpfile in it).
              <br />2. EPSG: 4326
              <br />3. Field 'type': 'boundary', 'obstacle' or 'nospray' for the type of plot.
              <br />4. Field 'name': for the boundary name on app.
              <br />5. Geometry type: polygon.
              <br />6. Boundary area: larger than 1㎡.
            </div>
            <el-upload name="file" class="upload-demo" action="/fieldmanagesystem/file/upload" :headers="headers"
              :data="uploadParams" :multiple="false" :on-success="uploadHandle" :file-list="fileList"
              :show-file-list="true">
              <el-button type="primary" icon="el-icon-upload">Upload
              </el-button>
            </el-upload>
          </el-tooltip>
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table ref="fileTable" size="small" :data="listData" highlight-current-row v-loading="loading"
        element-loading-text="Loading..." style="width: 100%">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column sortable prop="fileName" label="Name" width="300">
        </el-table-column>
        <el-table-column sortable prop="description" label="Description" width="300">
        </el-table-column>
        <el-table-column sortable prop="createTime" label="CreateTime" width="300">
        </el-table-column>
        <el-table-column sortable :formatter="formatBoolean" prop="isImport" label="IsImport" width="300">
        </el-table-column>

        <el-table-column align="center" label="Manage" min-width="300">
          <template slot-scope="scope">
            <!-- 删除 -->
            <el-button size="mini" type="danger" plain @click="deleteHandle(scope.$index, scope.row)">
              Delete
            </el-button>
            <!-- 重新导入 -->
            <el-button :disabled="scope.row.isImport" size="mini" type="primary" plain
              @click="reImportHandle(scope.$index, scope.row)">
              ReImport
            </el-button>
            <!-- 预览 -->
            <el-button size="mini" type="success" plain @click="viewMapHandle(scope.$index, scope.row)">
              ViewMap
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
    <div id="ViewPage" v-if="!isShowDataPage">
      <el-button class="BackBtn" v-if="showBackBtn" @click="backCommand" type="primary">Back</el-button>
      <div class="target-data-name">{{ selectFileName }}</div>
      <MapView name="map2" :isShowStatistic="isShowStatistic" :targetData="targetData"></MapView>
      <Confirm class="ConfirmBox" v-if="isShowConfirm" :message="confirmMessage" @confirmClick="confimImport"
        @cancleClick="cancleImport" />
    </div>
    <el-dialog title="Select system to import" :visible.sync="dialogFormVisible">
      <el-form>
        <el-radio v-model="reimportRadio" label="0">XAG One</el-radio>
        <el-radio v-model="reimportRadio" label="1">XAgri</el-radio>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="comfirmReimportCommand">Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import JSZip from "jszip";
import FileSaver from "file-saver";
import {
  listFile,
  searchFile,
  downloadFile,
  importToPlantSys,
  deleteByFileId,
  sendMessage,
} from "../api/fieldMG";
import Pagination from "../components/Pagination";
import MapView from "./map/map.vue";
import Confirm from "../components/confirm.vue";
export default {
  data() {
    return {
      // 重新导入系统
      dialogFormVisible: false,
      reimportRadio: "0",
      reimportFileId: null,

      // 显示返回按钮
      showBackBtn: false,
      isShowConfirm: false,
      isShowDataPage: true,
      isShowStatistic: false,

      loading: false, //是显示加载
      formInline: {
        currentPage: 1,
        pageSize: 15,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
        userId: localStorage.getItem("userId"),
        searchContent: "",
        startTime: "",
        endTime: "",
      },
      listData: [], //数据
      fileList: [],
      headers: {
        token: localStorage.getItem("logintoken"),
      },
      uploadParams: {
        userId: localStorage.userId,
        userUid: localStorage.userUid,
        description: "",
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 10,
      },
      targetData: [],
      selectFileName: "",
      confirmMessage: "Confirm selected, then upload!",
    };
  },
  // 注册组件
  components: {
    Pagination,
    MapView,
    Confirm,
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },

  methods: {
    getdata(parameter) {
      this.loading = true;
      listFile(parameter)
        .then((res) => {
          if (res.status == 200) {
            res = res.result;
            this.listData = res.records;
            this.pageparm.currentPage = this.formInline.currentPage;
            this.pageparm.pageSize = this.formInline.pageSize;
            this.pageparm.total = res.total;
            this.loading = false;
          }
        })
        .catch((e) => this.$message.error(e));
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.currentPage = parm.currentPage;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.loading = true;
      // 时间判空
      if (
        this.formInline.startTime == null ||
        this.formInline.startTime == ""
      ) {
        delete this.formInline.startTime;
      }
      if (this.formInline.endTime == null || this.formInline.endTime == "") {
        delete this.formInline.endTime;
      }
      // 判断开始时间小于结束时间
      if (this.formInline.endTime < this.formInline.startTime) {
        this.$notify({
          title: "Vertify",
          message: "startTime must be earlier then endTime",
          type: "warning",
        });
      }
      searchFile(this.formInline)
        .then((res) => {
          if (res.status != 200) {
            this.$message.error(res);
            return;
          }
          res = res.result;
          this.listData = res.records;
          this.pageparm.currentPage = this.formInline.currentPage;
          this.pageparm.pageSize = this.formInline.pageSize;
          this.pageparm.total = res.total;
          this.loading = false;
        })
        .catch((e) => this.$message.error(e));
    },

    uploadHandle(response, file, fileList) {
      if (response.status == null) {
        this.$message.error(response.message);
        return;
      }
      if (response.status != 200) {
        this.$message.error("file upload error!Check the format of the file!");
        return;
      }
      let res = response.result;
      // 设置数据页面不可见
      this.isShowDataPage = false;
      this.isShowConfirm = true;
      // 显示所选数据
      this.targetData = [res.fileId];
      this.selectFileName = res.fileName;
    },

    refreshFieldTable() {
      this.search();
    },

    // 确认上传
    confimImport(selectedSysId) {
      importToPlantSys({
        fileId: this.targetData[0],
        userName: localStorage.getItem("userName"),
        selectedSysId: selectedSysId,
      })
        .then((res) => {
          if (res.status != 200) {
            this.$message.error(
              "Fail to import to plant protect manage system! Try login out and login again!"
            );
          } else {
            this.refreshFieldTable();
            this.$message.success("upload complete!");
          }
        })
        .catch((e) => this.$message.error(e));
      this.isShowDataPage = true;
      this.isShowConfirm = false;
    },

    // 取消上传
    cancleImport() {
      this.isShowDataPage = true;
      this.isShowConfirm = false;
      this.$message.success("Cancel Import the Data!");
      this.refreshFieldTable();
    },

    // 批量下载
    async handleBatchDownload(fileList) {
      if (null == fileList || fileList.length <= 0) {
        this.$message.warning("Please select files for download firstly！");
        return;
      }
      const loading = this.$loading({
        lock: true, //lock的修改符--默认是false
        spinner: "el-icon-loading", //自定义加载图标类名
        text: "DownLoading",
        background: "rgba(0, 0, 0, 0.7)", //遮罩层颜色
        target: document.querySelector("#downloadBtn"), //loadin覆盖的dom元素节点
      });

      const zip = new JSZip();
      const cache = {};
      const promises = [];
      // throw 123;
      await fileList.forEach((item, index) => {
        const promise = downloadFile({ fileId: item.fileId }).then(
          (response) => {
            // 下载文件, 并存成ArrayBuffer对象
            let data = response.data;
            zip.file(index + "." + item.fileName, data, {
              binary: true,
            }); // 逐个添加文件
            cache[item.fileName] = data;
          }
        );
        promises.push(promise);
      });
      Promise.all(promises).then(() => {
        zip
          .generateAsync({
            type: "blob",
          })
          .then((content) => {
            // 生成二进制流
            FileSaver.saveAs(content, "fieldfile.zip"); // 利用file-saver保存文件
            this.$message.success("download success!");
            loading.close();
          });
      });
    },

    // 下载所选项
    async downloadSelected() {
      // 获取选中行
      var selection = this.$refs.fileTable.selection;
      try {
        await this.handleBatchDownload(selection);
      } catch (error) {
        this.$message.error("download error!" + error);
      }
    },

    // 预览所选项
    viewSelected() {
      // 获取选中行
      var selection = this.$refs.fileTable.selection;
      if (selection.length <= 0) {
        this.$message.warning("please select item first");
        return;
      }
      // 设置数据页面不可见
      this.isShowDataPage = false;
      this.showBackBtn = true;
      // 显示所选数据
      this.targetData = selection.map((p) => p.fileId);
    },

    // 预览当前项
    viewMapHandle(index, row) {
      // 设置数据页面不可见
      this.isShowDataPage = false;
      this.showBackBtn = true;
      // 显示所选数据
      this.targetData = [row.fileId];
      this.selectFileName = row.fileName;
    },

    // 重新导入，弹窗选择导入的系统
    reImportHandle(index, row) {
      this.reimportFileId = row.fileId;
      this.dialogFormVisible = true;
    },
    // 确定将当前项重新导入到植保系统
    comfirmReimportCommand() {
      if (null == this.reimportFileId) {
        return;
      }
      importToPlantSys({
        fileId: this.reimportFileId,
        userName: localStorage.getItem("userName"),
        selectedSysId: this.reimportRadio,
      })
        .then((res) => {
          if (res.status != 200) {
            this.$message.error(
              "Fail to import to plant protect manage system! Try login out and login again!"
            );
          } else {
            this.$message.success("upload complete!");
            this.refreshFieldTable();
          }
        })
        .catch((e) => this.$message.error(e));
      this.dialogFormVisible = false;
    },

    // 删除当前项
    deleteHandle(index, row) {
      this.$confirm("confirm to delete the field?", "Confirm", {
        confirmButtonText: "confirm",
        cancelButtonText: "cancle",
        type: "warning",
      })
        .then(() => {
          deleteByFileId({
            fileId: row.fileId,
            userName: localStorage.getItem("userName"),
          }).then((res) => {
            if (res.status != 200) {
              this.$message.warning("delete failed");
              return;
            }
            res = res.data;
            this.$message.success(row.fileName + " deleted successfully!");
            this.search();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "cancel delete",
          });
        });
    },

    // 退出预览，到数据管理页面
    backCommand() {
      this.isShowDataPage = true;
      this.showBackBtn = false;
    },

    /*布尔值格式化：cellValue为后台返回的值
     */
    formatBoolean: function (row, column, cellValue) {
      var ret = ""; //你想在页面展示的值
      if (cellValue) {
        ret = "imported"; //根据自己的需求设定
      } else {
        ret = "not imported";
      }
      return ret;
    },
  },
};
</script>

<style scoped>
.fieldManage {
  margin: 0%;
  padding: 30px;
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.BackBtn {
  width: 100px;
  position: absolute;
  margin: 10px;
  z-index: 2;
}

.ConfirmBox {
  z-index: 3;
  position: absolute;
  top: 72%;
  left: 40%;
}

.searchDate {
  width: 150px;
}

.target-data-name {
  position: absolute;
  margin-left: 35%;
  left: 240px;
  text-align: center;
  top: 10%;
  color: gray;
  font-weight: 500;
  z-index: 99;
}
</style>





// WEBPACK FOOTER //
// src/views/fieldManage.vue